<template>
  <div class="pages">
    <shortcut-bar class="shortcut-bar page-header" />
    <div class="page-header-placeholder"></div>

    <div class="content_box">
      <div>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ $t('首页') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('专题详情') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 地址 -->
      <div class="address_box">
        <div class="flex justify-between" style="margin-bottom: 24px">
          <p class="left_title">{{ $t('确认收货地址') }}</p>
          <p class="pointer text-61AC85">
            <span class="margin-right-48" @click="add_address = true">{{ $t('使用新地址') }}</span>
            <!-- <span>管理地址</span> -->
          </p>
        </div>
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item, index) in tableData" :key="index" class="margin-bottom-16">
            <div class="address_item pointer" :class="address_id == item.id ? 'addressPitch' : ''"
              @click="pitchAddress(item)">
              <img src="../../../static/images/icon/icon22.png" alt="" class="address_icon"
                v-if="address_id == item.id" />
              <img src="../../../static/images/icon/icon21.png" alt="" class="address_icon" v-else />
              <div>
                <p class="userData">
                  <span class="label_icon" v-if="item.is_default == 1">{{ $t('默认') }}</span>
                  <span>{{ item.province_name }}</span>
                  <span>{{ item.city_name }}</span>
                  <span>{{ item.district_name }}</span>
                  <span>{{ item.address }}</span>
                </p>
                <p>
                  <span>{{ item.consignee }}</span>
                  <span>{{ item.mobile }}</span>
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="lookOver" v-if="is_site == 0" @click="onSiteList(1)">
          {{ $t('查看全部地址') }}<img src="../../../static/images/icon/icon49.png" alt="" />
        </div>
        <div class="lookOver" v-if="is_site == 1" @click="onSiteList(0)">
          {{ $t('收起') }}<img src="../../../static/images/icon/icon50.png" alt="" />
        </div>
      </div>
      <!-- 下单信息 -->
      <div class="goods_box">
        <p class="box-tit">{{ $t('确认订单信息') }}</p>
        <div class="box-message justify-between">
          <div>
            <div class="message-left margin-bottom-24" v-for="(item, index) in goods_list">
              <img :src="item.product.cover" alt="" class="left-img">
              <div class="left-right flex flex-direction justify-between">
                <div class="left-right-top">
                  <div class="margin-bottom-16 text-16">{{ item.product.name }}</div>
                  <div class="margin-bottom-20 text-14 text-999" v-if="order_data.sku_price_id">{{ item.sku.name }}
                  </div>
                  <div class="text-14">{{ $t('单价：') }}￥{{ item.price }}</div>
                </div>
                <div class="left-right-bottom align-center justify-between">
                  <el-input-number v-model="item.num" @change="handleChange" :min="1"></el-input-number>
                  <div class="text-14 text-85674B">￥<span class="text-28">{{ (item.num * item.price).toFixed(2)
                      }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="message-right">
            <div class="right-tit">{{ $t('订单信息') }}</div>
            <div class="right-txt">
              <span class="text-999">{{ $t('邮费') }}</span>
              <span>{{ $t('包邮') }}￥0</span>
            </div>
            <div class="right-txt">
              <span class="text-999">{{ $t('优惠码') }}</span>
              <span class="pointer" @click="promotion_show = true">
                -￥{{ discountsData.coupon ? discountsData.coupon.amount : 0 }} <i class="el-icon-arrow-right"></i>
              </span>
            </div>
            <div class="right-txt">
              <span class="text-999">{{ $t('商品总价') }}</span>
              <span>￥{{ total_prices.toFixed(2) }}</span>
            </div>
            <div class="right-textarea">
              <div class="text-999">{{ $t('订单备注') }}</div>
              <textarea :placeholder="$t('请输入...')" v-model="remark"></textarea>
            </div>
            <div class="margin-top-24 margin-bottom-16 text-18 justify-between">
              <span>{{ $t('实付款') }}</span>
              <span>￥‌{{ prices ? prices.toFixed(2) : total_prices.toFixed(2) }}</span>
            </div>
            <div class="right-btn" @click="placeOrder">{{ $t('提交订单') }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加地址 start-->
    <transition name="orders-pop">
      <div class="pop" v-if="add_address">
      <div class="pop-box">
        <div class="box-tit">
          <span>{{ $t('新建地址') }}</span>
          <i class="el-icon-close" @click="add_address = false"></i>
        </div>
        <div class="box-ipt">
          <div class="box-ipt-tit">{{ $t('地址信息') }}</div>
          <!-- <el-cascader v-model="value" :options="options" @change="handleChange"></el-cascader> -->
          <el-cascader v-model="value" :props="props" @change="handleChangeSite"></el-cascader>
        </div>
        <div class="box-ipt">
          <div class="box-ipt-tit">{{ $t('详细地址') }}</div>
          <textarea :placeholder="$t('请输入详细地址')" v-model="site_data.address"></textarea>
        </div>
        <div class="box-ipt">
          <div class="box-ipt-tit">{{ $t('收货人姓名') }}</div>
          <input type="text" :placeholder="$t('请输入收货人姓名')" v-model="site_data.consignee">
        </div>
        <div class="box-ipt">
          <div class="box-ipt-tit">{{ $t('手机号码') }}</div>
          <div class="ipt-ipt">
            <el-dropdown @command="prefixHandleCommand" style="width: 50px;">
              <span class="el-dropdown-link">
                +{{ prefix }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="item.name" v-for="(item, index) in prefix_list" :key="index">
                  {{ item.name }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <input type="number" :placeholder="$t('请输入手机号码')" class="ipt-ipt-input" v-model="site_data.mobile">
          </div>
        </div>
        <el-checkbox v-model="checked" style="margin-top: 20px;">{{ $t('设置为默认收货地址') }}</el-checkbox>
        <div class="box-btn" @click="onAddSite">{{ $t('保存') }}</div>
      </div>
    </div>
    </transition>
    <!-- 添加地址 end -->
    <!-- 核销优惠码 start -->
    <transition name="orders-pop">
      <div class="pop" v-if="promotion_show">
      <div class="pop-box">
        <div class="align-center justify-between">
          <div style="width: 20px;"></div>
          <div>{{ $t('优惠码') }}</div>
          <i class="el-icon-close" @click="promotion_show = false" style="font-size: 20px;cursor: pointer;"></i>
        </div>
        <input type="text" :placeholder="$t('请输入您的优惠码')" class="promotion-ipt" v-model="coupon_code">
        <div class="promotion-btn">
          <div class="promotion-btn-l" @click="promotion_show = false">{{ $t('取消') }}</div>
          <div class="promotion-btn-r" @click="onCancel">{{ $t('确定') }}
          </div>
        </div>
      </div>
    </div>
    </transition>
    <!-- 核销优惠码 end -->
    <!-- 核销成功 start -->
    <transition name="orders-pop">
      <div class="succeedPop" v-if="succeed_show">
      <div class="succeedPop-box flex flex-direction align-center">
        <img src="../../../static/images/icon/icon19.png" alt="" class="box-img">
        <div class="text-20 margin-top-12 margin-bottom-24">{{ $t('核销成功！') }}</div>
        <div class="text-16 margin-bottom-8">{{ $t('优惠码：') }}{{ discountsData.coupon_code }}</div>
        <div class="text-16">{{ $t('优惠内容：') }}{{ discountsData.coupon.name }}</div>
        <div class="align-center succeedPop-box-btn">
          <div class="box-btn-r" @click="succeed_show = false">{{ $t('去使用') }}</div>
        </div>
      </div>
    </div>
    </transition>
    <!-- 核销成功 end -->
    <!-- 左侧悬浮框 -->
    <div class="pc-float">
      <leftSuspension />
    </div>

    <div style="height: 80px;"></div>
    <footer-bar></footer-bar>
  </div>
</template>

<style scoped>
.el-cascader {
  width: 100%;
}
</style>

<script>
import ShortcutBar from "@/components/ShortcutBar";
import leftSuspension from "@/components/leftSuspension.vue";
import { commodityOther, siteList, cityLinkage, addSite, unifyPlace, phonePrefix, discountsMessage } from '@/api/user';
import footerBar from '@/components/footerBar';

export default {
  name: "AppHeader",
  components: {
    'footer-bar': footerBar,
    "shortcut-bar": ShortcutBar,
    leftSuspension,
  },
  data() {
    return {
      orderNum: 1,
      remark: "",
      add_address: false,
      addressForm: {
        name: "",
        region: "",
      },
      formLabelWidth: "120px",
      checked: false,
      num: 1,//计数器数量
      promotion_show: false,//核销优惠码弹窗
      succeed_show: false,//核销成功弹窗
      tableData: [],//收货地址列表
      address_id: '',//收货地址id
      order_data: [],//上一页面传递信息
      goods_list: [],//订单信息
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          let pid = node.value || 0

          let options = []
          let data = {
            pid: pid,
            type: 1
          }
          // console.log(node);

          cityLinkage(data).then(res => {
            let list = res.data
            list.forEach(e => {
              for (let i in e.data) {
                options.push(e.data[i])
                e.data[i].leaf = node.level == 2
              }
            })
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(options);
          })
        }
      },//地址列表
      value: [],//地址
      site_data: {
        consignee: '',//收货人姓名
        mobile: '',//收货人联系方式
        address: '',//详细地址
        province_id: '',//省份ID
        city_id: '',//城市ID
        district_id: '',//地区ID
        province_name: '',//省份名称
        city_name: '',//城市名称
        district_name: '',//区名称
        street_id: '0'
      },//添加地址内容
      total_prices: 0,//商品总价
      remark: '', //订单备注
      from: 'goods',//数据来源，商品或购物车，goods，cart
      coupon_code: '',//优惠码
      prefix_list: [],//前缀列表
      prefix: '',//前缀
      discountsData: {},//优惠详情
      prices: 0,//价格
      is_site: 0//是否全部地址
    };
  },
  mounted() {
    let order_data = JSON.parse(decodeURIComponent(this.$route.params.order));
    this.order_data = order_data
    this.onSiteList(0)
    this.onPhonePrefix();
  },
  methods: {
    /**前缀切换 */
    prefixHandleCommand(e) {
      // console.log(e);
      this.prefix = e
    },
    /**手机号前缀 */
    onPhonePrefix() {
      phonePrefix().then(res => {
        this.prefix_list = res.data
        this.prefix = this.prefix_list[0].name
        // console.log(res.data);
      })
    },
    /**核销优惠码 */
    onCancel() {
      if (!this.coupon_code) {
        this.$message.warning('优惠码不能为空');
        return
      }
      let data = {
        coupon_code: this.coupon_code
      }
      discountsMessage(data).then(res => {
        if (res.code == 1) {
          this.$message.success(this.$t('领取成功'));
          this.discountsData = res.data
          this.succeed_show = true;

          if (this.total_prices > Number(res.data.coupon.enough)) {
            this.prices = this.total_prices - Number(res.data.coupon.amount)
          }
        } else {
          this.$message.warning(res.msg);
        }
        this.promotion_show = false;
      })
    },
    /**地址选中 */
    handleChangeSite(value) {
      console.log(value);
      this.site_data.province_id = value[0]
      this.site_data.city_id = value[1]
      this.site_data.district_id = value[2]
      for (let i = 0; i < 3; i++) {
        this.onCityLinkage(i)
      }
    },
    /**城市联动 */
    onCityLinkage(i) {
      let data = {
        type: 1
      }

      if (i == 0) {
        data.pid = 0
      } else if (i == 1) {
        data.pid = this.site_data.province_id
      } else if (i == 2) {
        data.pid = this.site_data.city_id
      }

      cityLinkage(data).then(res => {
        let list = res.data
        list.forEach(e => {
          for (let j in e.data) {
            if (e.data[j].value == this.site_data.province_id) {
              this.site_data.province_name = e.data[j].label
            }
            if (e.data[j].value == this.site_data.city_id) {
              this.site_data.city_name = e.data[j].label
            }
            if (e.data[j].value == this.site_data.district_id) {
              this.site_data.district_name = e.data[j].label
            }
          }
        })
      })
    },
    /**添加地址 */
    onAddSite() {
      this.site_data.is_default = Number(this.checked)
      if (!this.site_data.province_id) {
        this.$message.warning(this.$t('请选择地址'));
        return
      }
      if (!this.site_data.address) {
        this.$message.warning(this.$t('请输入详细地址'));
        return
      }
      if (!this.site_data.consignee) {
        this.$message.warning(this.$t('请输入收货人姓名'));
        return
      }
      if (!this.site_data.mobile) {
        this.$message.warning(this.$t('请输入手机号'));
        return
      }

      addSite(this.site_data).then(res => {
        if (res.code == 1) {
          this.$message.success(this.$t('地址添加完毕'));
          this.onSiteList()
          this.add_address = false
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
    /**选择地址 */
    pitchAddress(e) {
      console.log(e);
      this.address_id = e.id
    },
    /**地址列表 */
    onSiteList(i) {
      this.is_site = i
      siteList().then(res => {
        let list = res.data
        if (i == 0) {
          this.tableData = list.slice(0, 4)
        } else {
          this.tableData = list
        }
        list.forEach(e => {
          if (e.is_default == 1) {
            this.address_id = e.id
          }
        })
        this.onCommodityOther()
      })
    },
    /**商品预下单 */
    onCommodityOther() {
      let data = {
        goods_list: JSON.stringify(this.order_data),
        address_id: this.address_id
      }

      commodityOther(data).then(res => {
        let total_prices = 0
        let goods_list = res.data.goods_list
        this.goods_list = res.data.goods_list

        goods_list.forEach(e => {
          let price = e.num * e.price
          total_prices = total_prices + price
          this.total_prices = total_prices
        })
      })
    },
    /**步进器 */
    handleChange(value) {
      let total_prices = 0
      let goods_list = this.goods_list

      goods_list.forEach(e => {
        let price = e.num * e.price
        total_prices = total_prices + price
        this.total_prices = total_prices
      })
      // console.log(this.goods_list[0].num);
    },
    // 下单
    placeOrder() {
      let goods_list = []
      let list = this.goods_list

      list.forEach(e => {
        goods_list.push({
          product_id: e.product_id,
          sku_price_id: e.sku_price_id,
          num: e.num
        })
      })

      let data = {
        type: 'goods',
        goods_list: JSON.stringify(goods_list),
        address_id: this.address_id,
        remark: this.remark,
        from: this.from,
      }
      // console.log(data);
      if (this.discountsData.id) {
        data.coupon_id = this.discountsData.id
      }
      // console.log(data);
      // return
      unifyPlace(data).then(res => {
        if (res.code == 1) {
          let data = res.data
          this.$message.success(res.msg);
          setTimeout(res => {
            this.$router.replace({ name: "placeOrder", params: { order: encodeURIComponent(JSON.stringify(data)) } });
          }, 1000)
        } else {
          this.$message.warning(res.data);
        }
      })
    },
  }
};
</script>
<style scoped lang="scss">
.page-header {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.page-header-placeholder {
  height: 56px;
}

.pages {
  overflow: hidden;
  box-sizing: border-box;
}

.content_box {
  padding: 24px var(--page-gutter) 0;

  .left_title {
    color: #333;
    font-size: 18px;
  }

  .address_box {
    width: 100%;
    font-size: 16px;
    background: #fff;
    box-sizing: border-box;
    margin-top: 40px;
    /* // padding-bottom: 32px; */
    padding: 24px;
    /* // border-bottom: 1px solid #ccc; */
    border-radius: 12px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

    .address_item {
      min-height: 110px;
      display: flex;
      font-size: 14px;
      align-items: center;
      border-radius: 8px;
      padding: 20px;
      background: #FFFFFF;
      border: 2px dashed #999;
      box-sizing: border-box;
    }

    .addressPitch {
      border: 2px solid #61AC85;
      background: rgba(97, 172, 133, .1);
    }

    .address_icon {
      width: 38px;
      height: 38px;
      margin-right: 16px;
    }

    .userData {
      color: #333;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 8px;
    }

    .label_icon {
      color: #61AC85;
      width: 44px;
      height: 24px;
      font-size: 12px;
      font-weight: 400;
      padding: 2px 9px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #61AC85;
    }

    .lookOver {
      color: #333333;
      font-size: 14px;
      margin-top: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      img {
        width: 18px;
        height: 18px;
        margin-left: 6px;
      }
    }
  }

  .goods_box {
    .box-tit {
      font-size: 18px;
      margin-bottom: 24px;
      margin-top: 32px;
    }

    .box-message {
      .message-left {
        display: flex;
        padding: 24px 24px 24px 12px;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
        border-radius: 12px;

        .left-img {
          width: 200px;
          height: 200px;
          border-radius: 8px;
          object-fit: cover;
          object-position: center;
          flex-shrink: 0;
        }

        .left-right {
          width: 676px;
          padding-left: 24px;
          box-sizing: border-box;
        }
      }

      .message-right {
        padding: 24px 24px 32px;
        height: 450px;
        /* // border: 1px solid #EAEBEF; */
        /* // border-radius: 4px; */
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
        border-radius: 12px;

        .right-tit {
          font-size: 20px;
          color: #333333;
          margin-bottom: 30px;
          text-align: center;
        }

        .right-txt {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 12px;
          font-size: 14px;
        }

        .right-textarea {
          font-size: 14px;

          textarea {
            width: 100%;
            height: 104px;
            border: 1px solid #EEEEEE;
            border-radius: 4px;
            padding: 12px;
            box-sizing: border-box;
            margin-top: 8px;
            resize: none;
          }
        }

        .right-btn {
          width: 432px;
          height: 48px;
          background: #000000;
          border-radius: 4px;
          color: #FFFFFF;
          font-size: 18px;
          text-align: center;
          line-height: 48px;
          cursor: pointer;
        }
      }
    }
  }
}

.pop {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  /* background-color: rgba($color: #000000, $alpha: 0.5); */
  background-color: rgba(0, 0, 0, .5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  .pop-box {
    padding: 32px 24px;
    background: #FFFFFF;
    border-radius: 8px;
    width: 528px;
  }
}

.box-tit {
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    font-size: 20px;
    font-weight: 600;
  }

  i {
    font-size: 20px;
    cursor: pointer;
  }
}

.box-ipt {
  margin-top: 24px;
  font-size: 14px;

  .box-ipt-tit {
    margin-bottom: 10px;
    font-size: 16px;
  }

  .ipt-box {
    width: 100%;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    padding: 14px 12px;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
  }

  textarea {
    width: 100%;
    height: 96px;
    padding: 12px;
    box-sizing: border-box;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    resize: none;
  }

  input {
    width: 100%;
    height: 48px;
    padding: 12px;
    box-sizing: border-box;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
  }

  .ipt-ipt {
    width: 100%;
    /* // height: 48px; */
    padding: 12px;
    box-sizing: border-box;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    display: flex;

    .ipt-ipt-box {
      cursor: pointer;
    }

    .ipt-ipt-input {
      width: calc(100% - 70px);
      padding: 0;
      height: 100%;
      border: 0;
    }
  }
}

.box-btn {
  width: 100%;
  height: 48px;
  background: #000000;
  border-radius: 4px;
  color: #FFFFFF;
  text-align: center;
  line-height: 48px;
  font-size: 18px;
  margin-top: 48px;
  cursor: pointer;
}

.promotion-ipt {
  width: 100%;
  padding: 10px 16px;
  box-sizing: border-box;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  margin: 32px 0;
}

.promotion-btn {
  display: flex;
  justify-content: space-between;

  div {
    width: 120px;
    height: 35px;
    border-radius: 4px;
    text-align: center;
    line-height: 35px;
    box-sizing: border-box;
    font-size: 14px;
    cursor: pointer;
  }

  .promotion-btn-l {
    border: 1px solid #999999;

  }

  .promotion-btn-r {
    background: #000000;
    color: #FFFFFF;
  }
}

/**核销成功弹窗 */
.succeedPop {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  /* background-color: rgba($color: #000000, $alpha: 0.5); */
  background-color: rgba(0, 0, 0, .5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  .succeedPop-box {
    width: 400px;
    padding: 40px 0;
    background: #FFFFFF;
    border-radius: 8px;

    .box-img {
      width: 140px;
      height: 100px;
    }

    .succeedPop-box-btn {
      margin-top: 24px;

      .box-btn-r {
        width: 120px;
        height: 35px;
        box-sizing: border-box;
        border-radius: 8px;
        font-size: 14px;
        text-align: center;
        line-height: 35px;
        background: #000000;
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }
}

@media (max-width: 767px) {
  .pages {
    overflow-x: hidden;
    overflow-y: visible;
    width: 100%;
  }

  .page-header {
    padding-top: env(safe-area-inset-top, 0px);
  }

  .page-header-placeholder {
    height: calc(56px + env(safe-area-inset-top, 0px));
  }

  .pc-float {
    display: none;
  }

  .content_box {
    padding: 12px 16px 24px;
    box-sizing: border-box;
  }

  .content_box .left_title {
    font-size: 16px;
  }

  .content_box .address_box {
    margin-top: 16px;
    padding: 16px 12px;

    /deep/ .el-col {
      width: 100% !important;
      max-width: 100%;
    }

    .address_item {
      min-height: auto;
      padding: 12px;
    }

    .address_icon {
      width: 28px;
      height: 28px;
      margin-right: 10px;
      flex-shrink: 0;
    }

    .userData {
      font-size: 14px;
      word-break: break-all;
    }

    .lookOver {
      margin-top: 16px;
    }
  }

  .content_box .goods_box .box-tit {
    margin-top: 20px;
    margin-bottom: 12px;
    font-size: 16px;
  }

  .content_box .goods_box .box-message {
    flex-direction: column;
    align-items: stretch;
  }

  .content_box .goods_box .box-message .message-left {
    padding: 12px;

    .left-img {
      width: 88px;
      height: 88px;
      flex-shrink: 0;
    }

    .left-right {
      width: auto;
      flex: 1;
      min-width: 0;
      padding-left: 12px;
    }

    .left-right-bottom {
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 8px;
    }
  }

  .content_box .goods_box .box-message .message-right {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 16px 12px 20px;

    .right-tit {
      font-size: 16px;
      margin-bottom: 16px;
    }

    .right-btn {
      width: 100%;
    }
  }

  .pop .pop-box {
    width: calc(100vw - 32px);
    max-width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    padding: 20px 16px;
    box-sizing: border-box;
  }

  .promotion-btn div {
    width: calc(50% - 8px);
  }

  .succeedPop .succeedPop-box {
    width: calc(100vw - 32px);
    max-width: 100%;
    box-sizing: border-box;
  }

  @keyframes orders-fade-up {
    from {
      opacity: 0;
      transform: translateY(16px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .content_box > div:first-child {
    animation: orders-fade-up 0.35s ease both;
  }

  .content_box .address_box {
    animation: orders-fade-up 0.4s ease 0.06s both;
  }

  .content_box .goods_box {
    animation: orders-fade-up 0.45s ease 0.12s both;
  }

  .content_box .address_box .address_item {
    transition: border-color 0.25s ease, background-color 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease;
  }

  .content_box .address_box .address_item:active {
    transform: scale(0.98);
  }

  .content_box .address_box .addressPitch {
    box-shadow: 0 4px 12px rgba(97, 172, 133, 0.2);
  }

  .content_box .goods_box .box-message .message-left {
    transition: transform 0.2s ease, box-shadow 0.25s ease;
  }

  .content_box .goods_box .box-message .right-btn {
    transition: transform 0.15s ease, opacity 0.15s ease;
  }

  .content_box .goods_box .box-message .right-btn:active {
    transform: scale(0.98);
    opacity: 0.88;
  }

  .lookOver {
    transition: opacity 0.2s ease;
  }

  .lookOver:active {
    opacity: 0.6;
  }
}

.orders-pop-enter-active,
.orders-pop-leave-active {
  transition: opacity 0.28s ease;
}

.orders-pop-enter-active .pop-box,
.orders-pop-leave-active .pop-box,
.orders-pop-enter-active .succeedPop-box,
.orders-pop-leave-active .succeedPop-box {
  transition: transform 0.28s ease;
}

.orders-pop-enter,
.orders-pop-leave-to {
  opacity: 0;
}

.orders-pop-enter .pop-box,
.orders-pop-leave-to .pop-box,
.orders-pop-enter .succeedPop-box,
.orders-pop-leave-to .succeedPop-box {
  transform: translateY(20px) scale(0.96);
}
</style>



// WEBPACK FOOTER //
// src/view/order/orders.vue